import { render, staticRenderFns } from "./PackageOrder.vue?vue&type=template&id=e041acd4&scoped=true"
import script from "./PackageOrder.vue?vue&type=script&lang=js"
export * from "./PackageOrder.vue?vue&type=script&lang=js"
import style0 from "./PackageOrder.vue?vue&type=style&index=0&id=e041acd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e041acd4",
  null
  
)

export default component.exports